import { render, staticRenderFns } from "./value-chain.vue?vue&type=template&id=cea05fc6"
import script from "./value-chain.vue?vue&type=script&lang=js"
export * from "./value-chain.vue?vue&type=script&lang=js"
import style0 from "./value-chain.vue?vue&type=style&index=0&id=cea05fc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports